export default function Subscribed() {
    return (
        <>
            <h1>Page Coming Soon</h1>
        </>
    );
}
